export enum TemplateContentEnum {
    None = 0x00000000,
    Alarms = 0x00000001,
    TimeBands = 0x00000002,
    Delays = 0x00000004,
    Rollconfig = 0x00000008,
}

export function TemplateContentEnumToString(templateContent: TemplateContentEnum): string {
    let templateContentString = [];
    if ((templateContent & TemplateContentEnum.Alarms) != TemplateContentEnum.None) templateContentString.push(this.$t("security_management.alarms"));
    if ((templateContent & TemplateContentEnum.Delays) != TemplateContentEnum.None) templateContentString.push(this.$t("security_management.delays"));
    if ((templateContent & TemplateContentEnum.TimeBands) != TemplateContentEnum.None) templateContentString.push(this.$t("security_management.timeBands"));
    if ((templateContent & TemplateContentEnum.Rollconfig) != TemplateContentEnum.None) templateContentString.push(this.$t("reference_configuration.rollsConfig"));
    return templateContentString.join(", ");
}
